import {
    FORM_ADD_ITEM_QTY_TO_TRANSACTION,
    FORM_ADD_ITEM_TO_TRANSACTION,
    FORM_CALCULATE_ITEM,
    FORM_CALCULATE_TRANSACTION,
    FORM_REMOVE_ALL_ITEM_FROM_TRANSACTION,
    FORM_REMOVE_ITEM_FROM_TRANSACTION,
    FORM_SET_COMPANY_TRANSACTION,
    FORM_SET_DEFAULT,
    RESET_DETAIL,
    RESET_FORM,
    RESET_STATE,
    SET_DETAIL
} from "../constant-types"
import {
    getField,
    updateField
} from 'vuex-map-fields'
import {
    clearNotify,
    notify,
    requestSubmit,
    sendRequest,
    requestDelete
} from "./../api";
import {
    calculateCutResult, calculateTransaction, calculateTransactionItem, checkStockMustNotExceed
} from "./../helper";

const calculateCustomerCashChange = (state) => {
    // when no cash payment, should not count, and reset change
    if ( state.form.customer_cash_payment === 0 ) {
        state.form.customer_cash_change = 0
        return
    }
    // no need to calculate when no payment total for cash
    if ( state.form.customer_cash_total === 0 ) return
    // change only count when exceed payment total
    state.form.customer_cash_change = state.form.customer_cash_payment - state.form.customer_cash_total
}

const getDefaultState = () => {
    return {
        form: getDefaultFormState(),
        detail: null,
        sale_carts: [],
        selected_sale_cart: null
    }
}

const formatSaleCartForm = (state, rootState) => {
    // label with prefix 6 char from memo of first payment
    let label = state.form.customer ? state.form.customer.name : '---'
    let memo =  state.form.memo
    if ( memo ) label += '-' + memo.substr(0,6)

    return {
        cart_date : (new Date()).toISOString(),
        label,
        raw_data: JSON.stringify({
            sale : state.form,
            sale_payments : rootState.salePaymentForm.rows,
            vehicle_logs : rootState.vehicleLog.form_rows
        })
    }
}

const getDefaultFormState = () => {
    return {
        id: null,
        initial_date_time: (new Date()).toISOString(),
        customer_id: null,
        customer_crew_id: null,
        vehicle_id: null,
        stock_direction: 'direct', // direct | indent

        status_customer_taxed: false,

        payment_total: 0,
        payment_done: 0,
        payment_remain: 0,
        payment_type: 'cash', // cash or credit

        customer_cash_total: 0,
        customer_cash_to_user_cash_id: '',
        customer_cash_payment: 0,
        customer_cash_change: 0,

        price_total: 0,
        price_total_after_discount: 0,
        price_total_after_tax: 0,

        discount_nominal_from_item: 0,
        discount_word_from_total: '',
        discount_nominal_from_total: 0,
        discount_nominal: 0,

        tax_nominal_from_item: 0,
        tax_word_from_total: '',
        tax_nominal_from_total: 0,
        tax_nominal: 0,

        memo: null,

        sale_items: [],

        // ref
        /* stock_purchase_id: null,
        temp_purchase_code: '', // for temporary only */
        customer: null,
        //customer: { id: 1, name: 'sd', customer_crews: [], vehicles: []},
        customer_transaction: null,
        status_credit_payment: false, // for showing on form payment
        // business_type_id: 1, // to show product with taxed or not
        // show_payment_form : false
    }
}
export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [FORM_ADD_ITEM_TO_TRANSACTION](state, {
            stock,
            product
        }) {
            // let taxNominal = calculateCutResult(stockPurchase.purchase_item.purchase.tax_word_from_total, product.price_sell)
            let taxNominal = 0
            let newSaleItem = {
                sale_id: null,
                product_id: product.id,
                product: product,
                qty: 1,
                unit_id: product.unit_id,
                unit: product.unit,
                n_price: product.price_sell,
                price: 1 * product.price_sell,
                discount_word: '',
                discount_nominal: 0,
                price_after_discount: product.price_sell,
                tax_word: '',
                tax_nominal: taxNominal,
                price_after_tax: product.price_sell + taxNominal,

                // ref
                stock_warehouses: product.stock_warehouses,
                warehouse_id: null // for selected stock warehouse
                // stock_purchase_id: stockPurchase.id,
                // temp_purchase_code: stockPurchase.purchase_item.purchase_id,
                // temp_base_qty_balance: stockPurchase.base_qty_balance,
                // temp_base_qty_unit: product.base_qty,
                // temp_expire_date: stockPurchase.expire_date,
                // temp_have_purchase_tax: stockPurchase.purchase_item.purchase.tax_nominal_from_total > 0
            };
            state.form.sale_items.push(newSaleItem);
        },
        [FORM_REMOVE_ITEM_FROM_TRANSACTION](state, itemIndex) {
            state.form.sale_items.splice(itemIndex, 1)
        },
        [FORM_REMOVE_ALL_ITEM_FROM_TRANSACTION](state) {
            state.form.sale_items = []
        },
        [FORM_ADD_ITEM_QTY_TO_TRANSACTION](state, {
            stock,
            product,
            qtyToAdd = 1
        }) {
            // let existedSaleItem = _.find(state.form.sale_items, {
            //     product_item_id: productItem.id,
            //     stock_purchase_id: stockPurchase.id
            // });
            let idx = state.form.sale_items.findIndex(si => si.product_id == product.id)
            state.form.sale_items[idx].qty += qtyToAdd
        },
        [FORM_CALCULATE_TRANSACTION](state) {
            calculateTransaction(state.form, state.form.sale_items);
        },
        [FORM_CALCULATE_ITEM](state, saleItem) {
            // check stock must not exceed limit and product is good not services
            if ( state.form.stock_direction === 'direct' && saleItem.product.type === 'goods' ) {
                let currentTotalStock = _.sumBy(saleItem.stock_warehouses, 'base_qty_balance')
                if (!checkStockMustNotExceed(0, 1, currentTotalStock,
                        saleItem)) {
                    // reset qty
                    saleItem.qty = 1;
                }
            }
            calculateTransactionItem(saleItem, 'floor', 'floor');
        },
        FORM_CALCULATE_CUSTOMER_CASH_CHANGE(state) {
            calculateCustomerCashChange(state)
        },
        FORM_SET_FORM(state, payload) {
            state.form = Object.assign(state.form, payload)
        },
        [FORM_SET_DEFAULT](state, {
             saleDefaultCustomerId,
            // saleDefaultBusinessTypeId,
            //saleDefaultUserCashToId
        }) {
             state.form.customer_id = +saleDefaultCustomerId;
            // state.form.business_type_id = +saleDefaultBusinessTypeId;
            //state.form.sale_payment.to_user_cash_id = +saleDefaultUserCashToId;
        },
        [FORM_SET_COMPANY_TRANSACTION](state, customerTransaction) {
            state.form.customer_transaction = customerTransaction
        },
        // when customer changed by selector
        FORM_UPDATE_CUSTOMER(state, customer) {
            // this.resetTransaction();
            state.form.customer_id = customer.id;
            state.form.customer = customer // for reference for crew and vehicles
            // reset crew and vehicle
            state.form.customer_crew_id = null
            state.form.vehicle_id = null

            // state.form.status_customer_taxed = customer.customer_tax.status_pkp;
        },
        FORM_REMOVE_STOCKLESS_ITEM(state) {
            state.form.sale_items = state.form.sale_items.filter(si => si.stock_warehouses.length > 0)
        },
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [RESET_FORM](state) {
            state.form = getDefaultFormState()
        },
        [RESET_DETAIL](state) {
            state.detail = null
        },
        [SET_DETAIL](state, sale) {
            state.detail = sale
        },
        SET_SALE_CART(state, saleCarts) {
            state.sale_carts = saleCarts
        },
        SET_SELECTED_SALE_CART(state, saleCart) {
            state.selected_sale_cart = saleCart
        },
        RESET_SELECTED_SALE_CART(state) {
            state.selected_sale_cart = null
        },
        ADD_SALE_CART(state, saleCart) {
            state.sale_carts.unshift(saleCart)
        },
        REMOVE_SALE_CART(state, saleCart) {
            state.sale_carts.splice(state.sale_carts.findIndex(sc => sc.id === saleCart.id), 1)
        },
        UPDATE_SALE_CART(state, saleCart) {
            let idx = state.sale_carts.findIndex(sc => sc.id === saleCart.id)
            if (idx >=0) {
                state.sale_carts[idx] = JSON.parse(JSON.stringify(saleCart))
                //Object.assign(state.sale_carts[idx], saleCart)
                //Object.assign(state.sale_carts[idx], JSON.parse(JSON.stringify(saleCart)))
                //state.sale_carts.splice(idx, 1, saleCart)
            }
        },
        updateField
    },
    // can async
    actions: {
        formAddToCart({
            state,
            commit,
            dispatch
        }, {
            product,
            qty
        }) {
            let stock = product.stock
            // let product = stockPurchase.purchase_item.product_item.product;

            // add as increment if exist or as new
            let existedSaleItem = _.find(state.form.sale_items, {
                product_id: product.id,
            });
            // insert if new or only increment if exist
            if (_.isEmpty(existedSaleItem)) {
                // check stock must not exceed limit if have stock data
                if (stock) {
                    // when stock is direct sale, not demand
                    if ( state.form.stock_direction === 'direct' ) {
                        if ( !checkStockMustNotExceed(qty, 1, +stock.base_qty_balance) ) {
                            return
                        }
                    }
                } else {
                    // notify
                    notify('success', 'menambahkan ' + product.name, 2500)
                }
                commit(FORM_ADD_ITEM_TO_TRANSACTION, {
                    stock, product
                })
            } else {
                commit(FORM_ADD_ITEM_QTY_TO_TRANSACTION, {
                    stock,
                    product,
                    qtyToAdd: 1
                })
                // do recalc
                commit(FORM_CALCULATE_ITEM, existedSaleItem)
            }
            dispatch('formCalculateTransaction')
        },
        formCalculateTransaction({commit, state, dispatch}) {
            commit("FORM_CALCULATE_TRANSACTION")
            calculateCustomerCashChange(state)
            // update reference in salePaymentForm
            dispatch('salePaymentForm/updateReference', { payment_total : state.form.payment_total, sale_id : state.form.id, status_credit_payment: state.form.status_credit_payment }, { root : true })
        },
        // do after form set or reset
        formLoadDefault: async({
            commit, state,
            rootState
        }) => {
            let saleDefaultCustomerId = rootState.generalSetting.key_list.sale_default_customer_id
            await sendRequest(`customer/${saleDefaultCustomerId}`, {}, 'get', (successResponse) => {
                commit('updateField', { path: 'form.customer', value: successResponse })
            })

            commit(FORM_SET_DEFAULT, {
                saleDefaultCustomerId,
                // saleDefaultBusinessTypeId: rootState.generalSetting.key_list.sale_default_business_type_id,
                // saleDefaultUserCashToId: rootState.generalSetting.key_list.sale_default_user_cash_to_id,
            })
            // set default user cash on payment
            commit('salePaymentForm/updateField', { path: 'default_to_user_cash_id', value : +rootState.generalSetting.key_list.sale_default_user_cash_to_id }, { root : true })
            // set default from on payment using customer name
            //commit('salePaymentForm/updateField', { path: 'default_from', value : state.form.customer.name }, { root : true })
            // set first row payment default user cash
            commit('salePaymentForm/updateField', { path: 'rows.0.to_user_cash_id', value : +rootState.generalSetting.key_list.sale_default_user_cash_to_id }, { root : true })
        },
        // load customer transaction as request
        formLoadCustomerTransaction({
            state,
            commit
        }) {
            notify('info', 'merefresh info pelanggan...', null)
            sendRequest(`customer/transaction/${state.form.customer_id}`, {}, 'get',
                (customerTransaction) => commit(FORM_SET_COMPANY_TRANSACTION, customerTransaction),
                () => {},
                () => { clearNotify() }
            )
        },
        formRemoveFromCart({
            commit,
            dispatch
        }, itemIndex) {
            commit(FORM_REMOVE_ITEM_FROM_TRANSACTION, itemIndex)
            dispatch('formCalculateTransaction')
        },
        formRemoveAllFromCart({
            commit,
            dispatch
        }) {
            commit(FORM_REMOVE_ALL_ITEM_FROM_TRANSACTION)
            dispatch('formCalculateTransaction')
            // should reset payment too
            commit('salePaymentForm/RESET_FORM', null, { root : true })
        },
        formNewTransaction: async({commit, dispatch, rootState}) => {
            // notify('default', 'mengeset transaksi baru')
            commit(RESET_FORM)
            commit('RESET_SELECTED_SALE_CART')
            commit('salePaymentForm/RESET_FORM', null, { root : true })
            commit('vehicleLog/RESET_STATE', null, { root : true })
            await dispatch('formLoadDefault')
            await dispatch('userCash/loadList', null, { root : true })
        },
        formUpdateCustomer({ commit, state }, customer) {
            commit("FORM_UPDATE_CUSTOMER", customer)
            commit('salePaymentForm/updateField', { path: 'default_from', value : customer.name }, { root : true })
        },
        // refresh sale items stock in form
        formRefreshStockWarehouse({commit, state}) {
            // populate related product
            let productIds = state.form.sale_items.map(si => si.product_id)
            // fetch info
            return sendRequest('product/stock', { product_ids : productIds }, 'get',
                (fetchedProducts) => {
                    fetchedProducts.forEach(fp => {
                        // find and update sale_items.product.stock/stock_warehouses
                        let foundIdx = state.form.sale_items.findIndex(i => i.product_id === fp.id)
                        commit('updateField', { path: 'form.sale_items.' + foundIdx + '.stock', value: fp.stock })
                        commit('updateField', { path: 'form.sale_items.' + foundIdx + '.stock_warehouses', value: fp.stock_warehouses })
                    })
                }, () => {}, () => {}, false, false, false)
        },
        loadDetail({commit}, saleId) {
            return sendRequest(`sale/${saleId}`, {}, 'get', (sale) => commit(SET_DETAIL, sale))
        },
        loadSaleCart({commit}) {
            return sendRequest('sale-cart', {}, 'get', (saleCarts) => {
                commit('SET_SALE_CART', saleCarts)
            })
        },
        selectSaleCart({commit, state, dispatch}, saleCart) {
            commit('SET_SELECTED_SALE_CART', saleCart)
            // set sale
            let { sale, sale_payments, vehicle_logs } = JSON.parse(saleCart.raw_data)
            commit('FORM_SET_FORM', sale )
            // update stock balance inside saved cart
            dispatch('formRefreshStockWarehouse')
            // set payment
            dispatch('salePaymentForm/updateReference', { payment_total : sale.payment_total, sale_id: null, status_customer_taxed: sale.status_credit_payment }, { root : true })
            commit('salePaymentForm/SET_FORMS', sale_payments, { root : true })
            // set log if have
            commit('vehicleLog/SET_FORMS', vehicle_logs, { root : true })
        },
        saveSaleCart({commit, state, dispatch}) {
            if (state.selected_sale_cart) {
                dispatch('requestUpdateSaleCart', state.selected_sale_cart)
            } else {
                dispatch('requestCreateSaleCart')
            }
        },
        requestCreateSaleCart({commit, state, rootState, dispatch}) {
            // update when exist, create when new
            return sendRequest(`sale-cart`, formatSaleCartForm(state, rootState), 'post', (successResponse) => {
                notify('success', 'transaksi tersimpan')
                commit('ADD_SALE_CART', successResponse)
                // salect after save
                commit('SET_SELECTED_SALE_CART', successResponse)
                //// reset and open new transaction
                //dispatch('formNewTransaction')
            })
        },
        requestUpdateSaleCart({commit, state, rootState}, saleCart) {
            // update when exist, create when new
            return sendRequest(`sale-cart/${saleCart.id}`, formatSaleCartForm(state, rootState), 'put', (successResponse) => {
                notify('success', 'transaksi simpanan, terupdate')
                commit('UPDATE_SALE_CART', successResponse)
                commit('SET_SELECTED_SALE_CART', successResponse)
            })
        },
        requestDeleteSaleCart({commit, state}, saleCart) {
            return requestDelete(`sale-cart/${saleCart.id}`, {}, commit, saleCart.label, 'REMOVE_SALE_CART', undefined, undefined, (successResponse) => {
                // when selected, then should reset selected sale cart
                if (saleCart.id === state.selected_sale_cart.id) {
                    commit('RESET_SELECTED_SALE_CART')
                }
            })
        },
        requestDeleteSaleCartDirect({commit}, saleCart) {
            return sendRequest(`sale-cart/${saleCart.id}`, {}, 'delete', (successResponse) => {
                commit('REMOVE_SALE_CART', saleCart)
                commit('RESET_SELECTED_SALE_CART')
            }, () => {}, () => {}, false, false, false)
        },
        requestCreateSale({
            commit,
            state,
            dispatch, rootState
        }) {
            let createdForm = {
                ...state.form,
                // nominal zero should not send
                payments : rootState.salePaymentForm.rows.filter(spf => spf.nominal > 0),
                vehicle_logs: rootState.vehicleLog.form_rows
            }
            return requestSubmit('sale', createdForm, commit, 'post',
                (createdSale) => {
                    // remove selected sale cart
                    if (state.selected_sale_cart) {
                        dispatch('requestDeleteSaleCartDirect', state.selected_sale_cart)
                    }
                    commit(SET_DETAIL, createdSale)
                    // reset transaction
                    dispatch('formNewTransaction')
                    // refresh all posibility selector
                    app.$events.fire('refresh-selector')
                }
            )
        },
        requestCancelSale({commit, state}, saleId) {
            return requestSubmit(`sale/cancel/${saleId}`, {}, commit, 'post',
                (cancelledSale) => {
                    // refresh all posibility selector
                    app.$events.fire('refresh-selector')
                }
            )
        }
    },
    // call variable with custom display
    getters: {
        // validate input should have label and real nominal
        formVehicleLogValidated(state, getters, rootState) {
            if (rootState.vehicleLog.form_rows.length > 0) {
                return _.every(rootState.vehicleLog.form_rows, function(o) {
                    return o.label != "" && o.value != "";
                })
            } else {
                return true;
            }
        },
        // should lock if some sale items, from purchase item that have tax
        formLockTaxFromTotal(state) {
            if (_.find(state.form.sale_items, {
                    temp_have_purchase_tax: true
                })) {
                return true;
            } else {
                return false;
            }
        },
        formSumSaleItemNominal(state) {
            return _.sumBy(state.form.sale_items, 'price_after_tax');
        },
        formReady(state, getters) {
            return state.form.customer_id && state.form.sale_items.length > 0 && state.form.payment_total > 0 && getters.formVehicleLogValidated && state.form.customer_cash_change >= 0;
        },
        saleCarts: state => {
            // sort by descending
            return state.sale_carts.sort((a, b) => b.id - a.id)
        },
        detailPaymentsDone: state => {
            if (!state.detail) return
            if (!state.detail.sale_payments) return
            if ( state.detail.sale_payments.length === 0 ) return;

            let result =  state.detail.sale_payments.filter(sp => sp.status_paid === true)

            if (result.length === 0) return

            return result
        },
        detailLatestDatePaymentDone: state => {
            if (!state.detail) return
            if (!state.detail.sale_payments) return
            if ( state.detail.sale_payments.length === 0 ) return;

            let result =  state.detail.sale_payments.filter(sp => sp.status_paid === true)
                .map(spm => spm.paid_date_time)

            if (result.length === 0) return

            return result.reduce((a, b) => a > b ? a : b)
        },
        detailFirstUnpaidDueDate: state => {
            if (!state.detail) return
            if (!state.detail.sale_payments) return
            if ( state.detail.sale_payments.length === 0 ) return;

            let result = state.detail.sale_payments.filter(sp => sp.status_paid === false )
                .map(sdd => sdd.due_date)

            if (result.length === 0) return

            return result.reduce((a, b) => a < b ? a : b)
        },
        getField
    }
})
